"use strict";
/**
 * Canonical Mutual NDA (MNDA) for Enterprise Audit onboarding.
 * Agreement body plain text is committed in the backend repo (`enterpriseAuditMndaBody.txt`), with an
 * optional `AUDIT_MNDA_BODY_TEXT_LOCAL_PATH` override on the server.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_MNDA_ACKNOWLEDGMENT_PDF_BODY = exports.AUDIT_MNDA_NEWFORM_SIGNATORY_TITLE = exports.AUDIT_MNDA_NEWFORM_SIGNATORY_NAME = void 0;
/** NewForm signatory pre-printed on the post-acceptance PDF (matches canonical MNDA). */
exports.AUDIT_MNDA_NEWFORM_SIGNATORY_NAME = "Hamza Alsamraee";
exports.AUDIT_MNDA_NEWFORM_SIGNATORY_TITLE = "CEO";
/**
 * Body for the signed acknowledgment PDF emailed after NDA acceptance.
 * The full agreement is the attached Word document.
 */
exports.AUDIT_MNDA_ACKNOWLEDGMENT_PDF_BODY = `MUTUAL NON-DISCLOSURE AGREEMENT — ACKNOWLEDGMENT

The complete Mutual Non-Disclosure Agreement between NewForm and your organization is provided as the accompanying Microsoft Word document (“MNDA”).

By signing below, you confirm that you have read the MNDA in full, that you have authority to bind your organization, and that your organization accepts and agrees to be bound by the MNDA’s terms.`;
